import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Clock, ArrowRight, ChevronRight } from 'lucide-react';

const articles = [
  {
    id: 7,
    slug: 'organiser-mariage-etretat',
    title: 'Organiser un Mariage à Étretat : Le Guide Complet 2026',
    excerpt: "Se marier face aux falaises d'Étretat fait rêver des milliers de couples. Mais derrière la carte postale se cache une logistique exigeante : vent marin, accès restreint, sites protégés. Voici notre guide complet pour réussir votre mariage à Étretat en 2026.",
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80',
    category: 'Événementiel',
    date: '2026-02-15',
    readTime: '13 min',
    city: 'Étretat',
    citySlug: 'etretat'
  },
  {
    id: 8,
    slug: 'location-barnum-evenement-rouen',
    title: 'Location Barnum pour Événement à Rouen : Chapiteaux, Tentes et Conseils',
    excerpt: "Organiser un événement à Rouen ou dans la métropole rouennaise ? Mariages dans les châteaux, séminaires d'entreprise, fêtes de village : la location de barnum est incontournable. Découvrez comment choisir la bonne structure et notre zone de livraison.",
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80',
    category: 'Événementiel',
    date: '2026-02-12',
    readTime: '11 min',
    city: 'Rouen',
    citySlug: 'rouen'
  },
  {
    id: 9,
    slug: 'mariage-honfleur-guide-2026',
    title: 'Mariage à Honfleur : Location de Mobilier Événementiel Haut de Gamme',
    excerpt: "Honfleur, avec son Vieux Bassin et ses maisons à colombages, est l'un des écrins les plus prisés de Normandie pour les mariages d'exception. Chapiteaux premium, vaisselle, sono, éclairage : voici notre guide complet pour votre mariage à Honfleur.",
    image: 'https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&q=80',
    category: 'Événementiel',
    date: '2026-02-08',
    readTime: '12 min',
    city: 'Honfleur',
    citySlug: 'honfleur'
  },
  {
    id: 1,
    slug: 'location-chateau-gonflable-le-havre',
    title: 'Location de Château Gonflable au Havre - Anniversaires Enfants Réussis',
    excerpt: "Tu cherches à organiser un anniversaire inoubliable pour ton enfant au Havre ? La location de château gonflable est LA solution idéale pour transformer une simple fête en un moment magique.",
    image: '/media/blog-image-1769376013499-doi9vx1c-cf0f8d52.jpg',
    category: 'Événementiel',
    date: '2026-01-25',
    readTime: '8 min'
  },
  {
    id: 2,
    slug: 'location-barnum-le-havre',
    title: 'Location Barnum Le Havre : Guide Complet 2026 pour Réussir Votre Événement',
    excerpt: "Organiser un événement au Havre et en Seine-Maritime nécessite une préparation minutieuse. Face au climat normand imprévisible, la location de barnum s'impose comme la solution idéale.",
    image: '/media/blog-image-1769361425581-i3kmq8sh-01172bc3.jpg',
    category: 'Événementiel',
    date: '2026-01-24',
    readTime: '12 min'
  },
  {
    id: 6,
    slug: 'location-plancher-bois-evenement',
    title: 'Location Plancher Bois pour Événement : Guide Complet 2026',
    excerpt: "Le choix du sol est un élément crucial qui peut faire toute la différence entre une réception réussie et un événement gâché. La location d'un plancher adapté garantit confort, sécurité et esthétique.",
    image: '/media/blog-image-1769362091598-hveboawv-793c2ab0.jpg',
    category: 'Événementiel',
    date: '2026-01-23',
    readTime: '11 min'
  },
  {
    id: 3,
    slug: 'location-broyeur-vegetaux-le-havre',
    title: 'Location Broyeur Végétaux Thermique au Havre : Guide Complet',
    excerpt: "Face à l'accumulation de branches après un élagage ou une tempête, la location d'un broyeur végétaux thermique s'impose comme la solution idéale pour les propriétaires de jardin.",
    image: '/media/blog-image-1769357025452-te9jz524-4a7cbe52.jpg',
    category: 'Jardin',
    date: '2026-01-22',
    readTime: '10 min'
  },
  {
    id: 4,
    slug: 'location-betonniere-360l-normandie',
    title: 'Location de bétonnière 360 L pour vos projets en Normandie',
    excerpt: "Vous avez un projet de terrasse, de fondations pour votre garage, ou d'allée en béton ? La location d'une bétonnière 360L représente la solution idéale pour concrétiser vos travaux.",
    image: '/media/blog-image-1769355414344-xqikcdj4-1a283dd8.jpg',
    category: 'BTP',
    date: '2026-01-21',
    readTime: '15 min'
  },
  {
    id: 5,
    slug: 'location-mini-pelle-guide-2026',
    title: 'Location Mini Pelle : Pourquoi et Quand Louer ? Guide Complet 2026',
    excerpt: "La mini pelle se distingue comme l'outil polyvalent par excellence pour une multitude de travaux de terrassement, d'excavation et d'aménagement extérieur.",
    image: '/media/blog-image-1769353529791-0jo2m7tn-3c1b56d6.jpg',
    category: 'BTP',
    date: '2026-01-20',
    readTime: '14 min'
  }
];

const categories = ['Tous', 'Événementiel', 'BTP', 'Jardin'];

const ActualitesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('Tous');

  const filteredArticles = selectedCategory === 'Tous' 
    ? articles 
    : articles.filter(article => article.category === selectedCategory);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('fr-FR', { 
      day: 'numeric', 
      month: 'long', 
      year: 'numeric' 
    });
  };

  return (
    <div className="min-h-screen bg-slate-50">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 py-20">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <span className="inline-block px-4 py-2 bg-green-500/20 text-green-400 font-semibold rounded-full text-sm mb-6">
            Blog & Conseils
          </span>
          <h1 className="text-4xl sm:text-5xl font-black text-white mb-6">
            Nos <span className="text-green-400">Actualités</span>
          </h1>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto">
            Guides pratiques, conseils d'experts et astuces pour réussir tous vos projets de location de matériel
          </p>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4">
          <div className="flex flex-wrap gap-3 justify-center">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-2 rounded-full font-medium transition-all ${
                  selectedCategory === category
                    ? 'bg-green-500 text-white shadow-lg shadow-green-500/30'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
                data-testid={`category-filter-${category.toLowerCase()}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4">
          {/* Featured Article */}
          {filteredArticles.length > 0 && (
            <div className="mb-12">
              <Link 
                to={`/actualites/${filteredArticles[0].slug}`}
                className="group block bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500"
                data-testid="featured-article"
              >
                <div className="grid lg:grid-cols-2">
                  <div className="relative h-64 lg:h-auto">
                    <img
                      src={filteredArticles[0].image}
                      alt={filteredArticles[0].title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="px-4 py-1 bg-green-500 text-white text-sm font-semibold rounded-full">
                        À la une
                      </span>
                    </div>
                  </div>
                  <div className="p-8 lg:p-12 flex flex-col justify-center">
                    <span className="inline-block px-3 py-1 bg-green-100 text-green-600 text-sm font-medium rounded-full mb-4 w-fit">
                      {filteredArticles[0].category}
                    </span>
                    <h2 className="text-2xl lg:text-3xl font-bold text-slate-800 mb-4 group-hover:text-green-600 transition-colors">
                      {filteredArticles[0].title}
                    </h2>
                    <p className="text-slate-600 mb-6 line-clamp-3">
                      {filteredArticles[0].excerpt}
                    </p>
                    <div className="flex items-center gap-6 text-sm text-slate-500 mb-6">
                      <span className="flex items-center gap-2">
                        <Calendar size={16} />
                        {formatDate(filteredArticles[0].date)}
                      </span>
                      <span className="flex items-center gap-2">
                        <Clock size={16} />
                        {filteredArticles[0].readTime} de lecture
                      </span>
                    </div>
                    <span className="inline-flex items-center gap-2 text-green-600 font-semibold group-hover:gap-4 transition-all">
                      Lire l'article
                      <ArrowRight size={20} />
                    </span>
                  </div>
                </div>
              </Link>
            </div>
          )}

          {/* Other Articles */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredArticles.slice(1).map((article) => (
              <Link
                key={article.id}
                to={`/actualites/${article.slug}`}
                className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300"
                data-testid={`article-card-${article.id}`}
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={article.image}
                    alt={article.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute top-4 left-4">
                    <span className="px-3 py-1 bg-white/90 backdrop-blur-sm text-slate-700 text-xs font-semibold rounded-full">
                      {article.category}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-lg font-bold text-slate-800 mb-3 line-clamp-2 group-hover:text-green-600 transition-colors">
                    {article.title}
                  </h3>
                  <p className="text-slate-600 text-sm mb-4 line-clamp-2">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between text-xs text-slate-500">
                    <span className="flex items-center gap-1">
                      <Calendar size={14} />
                      {formatDate(article.date)}
                    </span>
                    <span className="flex items-center gap-1">
                      <Clock size={14} />
                      {article.readTime}
                    </span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div className="text-center py-16">
              <p className="text-slate-500 text-lg">Aucun article dans cette catégorie pour le moment.</p>
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-green-600 to-green-500">
        <div className="max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Besoin de conseils personnalisés ?
          </h2>
          <p className="text-green-100 text-lg mb-8">
            Notre équipe est à votre disposition pour vous accompagner dans tous vos projets
          </p>
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 bg-white text-green-600 font-bold rounded-xl hover:bg-green-50 transition-colors"
            data-testid="cta-contact-btn"
          >
            Nous contacter
            <ChevronRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default ActualitesPage;
